import React from "react";
import { Beer, sortBeersForSelection } from "../../data/types";
import "./BeerSelect.scss";
import BeerSlot from "../BeerSlot/BeerSlot";

interface BeerSelectProps {
  onSelect: (beer: Beer) => void;
  beers: Beer[]; // Lägg till en lista med ölsorter som kommer skickas in
  onClose: () => void; // En funktion för att stänga popupen
}

const BeerSelect: React.FC<BeerSelectProps> = ({
  onSelect,
  beers,
  onClose,
}) => {
  // Stänger popupen när användaren klickar utanför
  const handleClosePopup = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const sortedBeers = sortBeersForSelection(beers);

  return (
    <div className="beer-select-overlay" onClick={handleClosePopup}>
      <div className="beer-options">
        {sortedBeers.map((beer) => (
          <BeerSlot
            key={beer.id}
            index={0}
            beer={beer}
            handleSelect={onSelect}
            unavailable={beer.available === false}
          />
        ))}
      </div>
      <button className="close-btn" onClick={onClose}>
        <img src="/cancel.svg" alt="Cancel icon" />
      </button>
    </div>
  );
};

export default BeerSelect;
